module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/mentor.json
// module id = 1038
// module chunks = 160501532859649